import { Button } from "@altimateai/lego";
import { updateRightPanelState } from "./DbtDocsReducer";
import {
  useDbtDocsCollaborationContext,
  useDbtDocsCollaborationDispatch,
} from "./DbtDocsCollaborationProvider";

const ShowConversationsButton = () => {
  const {
    state: { isRightPanelOpen },
  } = useDbtDocsCollaborationContext();
  const dispatch = useDbtDocsCollaborationDispatch();

  const toggleRightPanel = () => {
    dispatch(updateRightPanelState(!isRightPanelOpen));
  };
  return (
    <Button onClick={toggleRightPanel}>
      {isRightPanelOpen ? "Hide conversations" : "Show conversations"}
    </Button>
  );
};

export default ShowConversationsButton;
